// extracted by mini-css-extract-plugin
module.exports = {"navbarHeight":"70px","reward-container":"styles_reward-container__18zSU","rewardContainer":"styles_reward-container__18zSU"};